import React from "react";
import { Outlet } from "react-router-dom";

const AdminWrapper = () => {



    return (
        <main className="workspace">
            <Outlet />
        </main>
    )


}

export default AdminWrapper;